<template>
  <Modal :id="id" :title="title">
    <div slot="body" class="modal-body modal-form">
      <div v-if="learningPathOptions.length > 0" class="row">
        <div class="col-12">
          <p>
            Use the drop down menu below to associate this user's course
            registration with the selected learning path.
          </p>
        </div>
        <div class="col-12">
          <div class="form-group">
            <Field
              type="select"
              name="learning_path"
              v-model="selectedPath"
              :options="learningPathOptions"
              :hide-select-empty-option="true"
            />
          </div>
        </div>
      </div>
      <div v-else-if="showNoResults" class="alert alert-danger text-center">
        There are currently no learning paths available.
      </div>
    </div>
    <div slot="footer" class="modal-footer">
      <a
        v-if="learningPathOptions.length > 0"
        class="btn btn-success"
        href="#"
        @click.prevent="submit"
        >Save</a
      >
      <a class="btn btn-info" href="#" @click.prevent="close">Cancel</a>
    </div>
  </Modal>
</template>

<script>
import ModalMixin from "mixins/Modal";
export default {
  mixins: [ModalMixin],
  data() {
    return {
      id: "add-to-learning-path-modal",
      enrollment: null,
      learningPaths: [],
      selectedPath: null,
      showNoResults: false,
    };
  },
  computed: {
    title() {
      return !!this.enrollment.learning_path_enrollment_id
        ? "Re-assign Learning Path"
        : "Add to Learning Path";
    },
    learningPathOptions() {
      let options = [];
      options.push({
          label: 'None',
          value: 0
      });
      if (this.learningPaths.length > 0) {
        this.learningPaths.forEach((path) => {
          options.push({
            label: path.name,
            value: path.id,
          });
        });
      }
      return options;
    },
  },
  methods: {
    load() {
      this.$root.showLoading();
      this.axios
        .get(this.route("learning-paths.list"), {
          params: {
            ...{ "pagination[current]": 1 },
            ...{ "pagination[per_page]": 100 },
            ...{ "sort[column]": "name" },
            ...{ "sort[dir]": "asc" },
          },
        })
        .then((response) => {
          if (response.data.results.length > 0) {
            this.learningPaths = response.data.results;
          } else {
            this.showNoResults = true;
          }
          this.$root.hideLoading();
        });
    },
    submit() {
      this.axios
        .post(
          this.route("admin.learning-paths.add-to-path", {
            enrollment: this.enrollment.id,
          }),
          { learning_path_id: this.selectedPath }
        )
        .then((response) => {
          this.resolve(response.data);
        });
    },
  },
  created() {
    this.enrollment = _.cloneDeep(this.options.enrollment);
    if (!!this.options.learning_path_id) {
      this.selectedPath = this.options.learning_path_id;
    } else if (!!this.enrollment.learning_path_enrollment) {
      this.selectedPath = this.enrollment.learning_path_enrollment.learning_path_id;
    }
    this.load();
  },
};
</script>